import { createContext, useContext, type ReactNode } from "react";
import { useStore } from "zustand";
import type { SessionState, SessionStore } from "./session";

const SessionContext = createContext<SessionStore | null>(null);

export function SessionProvider({
  store,
  children,
}: {
  store: SessionStore;
  children: ReactNode;
}): ReactNode {
  return <SessionContext.Provider value={store}>{children}</SessionContext.Provider>;
}

/** The raw session store — for imperative reads/writes (`.getState()`) outside a selector,
 *  e.g. reacting to a one-off event without subscribing to the slice. */
export function useSessionStore(): SessionStore {
  const store = useContext(SessionContext);
  if (!store) throw new Error("useSession must be used within a <SessionProvider>");
  return store;
}

/** Subscribe to a slice of session state. */
export function useSession<T>(selector: (state: SessionState) => T): T {
  return useStore(useSessionStore(), selector);
}
